import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 460px;
  background: var(--grey-25);
  position: relative;
  border-radius: 40px;

  @media (max-width: 768px) {
    height: 360px;
  }
`
export const Content = styled.div`
  width: 80%;
  position: absolute;
  top: calc(50% - calc(118px / 3)); /* 118px: WaveDivider height */
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  text-align: center;

  @media (max-width: 768px) {
    top: calc(50% - calc(55px / 3)); /* 55px: WaveDivider height */
  }
`
export const Label = styled.span`
  color: var(--brand-secondary);
  font-size: 18px;
  font-weight: var(--font);
  margin-bottom: 25px;
  display: block;
`
